import React, { useState } from 'react';
import moment from 'moment';
import { Chip } from '@mui/material';
import './payroll.css'
import MyTable from '../../components/Schedule/MyTable';
import Modal from 'react-bootstrap/Modal';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import ApiService from "../../functions/apiService";
import { Col, Row } from 'react-bootstrap';

const PAYCODE_STYLES = {
    OVERTIME:   { bg: '#FEF3C7', color: '#92400E' },
    CALLBACK:   { bg: '#DBEAFE', color: '#1E40AF' },
    LATE_CALL:  { bg: '#EDE9FE', color: '#5B21B6' },
    ADJUSTMENT: { bg: '#D1FAE5', color: '#065F46' },
    DEFAULT:    { bg: '#F3F4F6', color: '#374151' },
};

const paycodeStyle = (code) =>
    PAYCODE_STYLES[code] || PAYCODE_STYLES.DEFAULT;

const PaycodePill = ({ value }) => {
    if (!value) return '—';
    const { bg, color } = paycodeStyle(value);
    return (
        <Chip
            label={value}
            size="small"
            sx={{
                backgroundColor: bg,
                color,
                fontWeight: 600,
                fontSize: '11px',
                height: '22px',
                borderRadius: '6px',
            }}
        />
    );
};

const HrsPill = ({ value }) => {
    if (value === undefined || value === null || value === 'N/A') return <span style={{ color: '#9CA3AF' }}>—</span>;
    const hrs = parseFloat(value);
    const bg = hrs >= 8 ? '#FEE2E2' : hrs >= 4 ? '#FEF3C7' : '#ECFDF5';
    const color = hrs >= 8 ? '#991B1B' : hrs >= 4 ? '#92400E' : '#065F46';
    return (
        <Chip
            label={`${hrs % 1 === 0 ? hrs.toFixed(0) : hrs}`}
            size="small"
            sx={{
                backgroundColor: bg,
                color,
                fontWeight: 700,
                fontSize: '12px',
                height: '22px',
                borderRadius: '6px',
                minWidth: '36px',
            }}
        />
    );
};

const RunPill = ({ value }) => {
    if (!value || value === '0' || value === 'N/A' || value === 'NA') {
        return <span style={{ color: '#9CA3AF', fontSize: '13px' }}>—</span>;
    }
    return (
        <Chip
            label={value}
            size="small"
            variant="outlined"
            sx={{
                borderColor: '#D1D5DB',
                color: '#374151',
                fontWeight: 500,
                fontSize: '11px',
                height: '22px',
                borderRadius: '6px',
            }}
        />
    );
};

const ListView = ({ data, refresh }) => {
    const [deletModal, setDeleteModal] = useState(false)
    const [selectedRecord, setSelectedRecord] = useState(null);

    const handleDeleteClick = (record) => {
        setSelectedRecord(record);
        setDeleteModal(true);
    };

    const handleDelete = async () => {
        if (!selectedRecord) return;
        try {
            const response = await ApiService.post('/payroll/delete-payrollRecord', {
                Shift_Number: selectedRecord.shift_number,
                Shift_Date: selectedRecord.shift_date
            });
            toast.success(response.message)
            refresh()
            setDeleteModal(false);
        } catch (error) {
            toast.error(error.message)
        }
    };

    const columns = [
        {
            field: 'date', headerName: 'Date', flex: 1, minWidth: 100, sortable: false,
            valueGetter: (params) => params.row.shift_date,
            renderCell: (params) => params.row.shift_date
                ? moment(params.row.shift_date).format('MM/DD/YYYY')
                : '—'
        },
        {
            field: 'name', headerName: 'Name', flex: 1.2, minWidth: 130, sortable: false,
            valueGetter: (params) => params.row.employee_name
        },
        {
            field: 'runNumber', headerName: 'Run #', flex: 0.8, minWidth: 90, sortable: false,
            valueGetter: (params) => params.row.assignment_code,
            renderCell: (params) => <RunPill value={String(params.row.assignment_code)} />
        },
        {
            field: 'reason', headerName: 'Reason', flex: 2, minWidth: 160, sortable: false,
            valueGetter: (params) => params.row.detail_text
        },
        {
            field: 'time', headerName: 'Time', flex: 1.1, minWidth: 120, sortable: false,
            renderCell: (params) => {
                const start = params.row.start_time ? params.row.start_time.slice(0, 5) : '—';
                const end = params.row.end_time ? params.row.end_time.slice(0, 5) : '—';
                return <span style={{ fontVariantNumeric: 'tabular-nums' }}>{start} – {end}</span>;
            }
        },
        {
            field: 'hours', headerName: 'Hrs', flex: 0.6, minWidth: 70, sortable: false,
            valueGetter: (params) => params.row.hours,
            renderCell: (params) => <HrsPill value={params.row.hours} />
        },
        {
            field: 'paycode', headerName: 'Paycode', flex: 1.1, minWidth: 110, sortable: false,
            valueGetter: (params) => params.row.pay_code,
            renderCell: (params) => <PaycodePill value={params.row.pay_code} />
        },
        {
            field: 'createdBy', headerName: 'Created by', flex: 1.2, minWidth: 130, sortable: false,
            valueGetter: (params) => params.row.created_by
        },
        {
            field: 'timestamp', headerName: 'Timestamp', flex: 1.3, minWidth: 150, sortable: false,
            valueGetter: (params) => params.row.create_time,
            renderCell: (params) => params.row.create_time
                ? moment(params.row.create_time).format('MM/DD/YYYY h:mm A')
                : '—'
        },
        {
            field: 'action', headerName: 'Action', flex: 0.5, minWidth: 70,
            renderCell: (params) => (
                <div style={{ gap: 10, display: 'flex' }}>
                    <img src='/images/delete.svg' style={{ cursor: 'pointer' }}
                        onClick={() => handleDeleteClick(params.row)}
                    />
                </div>
            )
        },
    ]

    return (
        <>
            <MyTable
                rows={data}
                columns={columns}
                hideFooter={true}
                checkboxSelection={false}
                minHeightRow='40px'
            />
            <Modal show={deletModal} onHide={() => setDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Record</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        Are you sure to delete this Record?
                    </div>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setDeleteModal(false)}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={handleDelete}>
                                Delete
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ListView;
